import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectionTypeListing, CollectionTypeAddEdit } from './Pages';

export const CollectionTypeRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CollectionTypeListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={CollectionTypeAddEdit} />
    </Fragment>
)